<template>
  <div class="m-cloudMarkDetail">
    <div class="cloudMarkDetail_commodity commodity_service">
      <div class="go_back_common">
        <div class="go_back_title" @click="back">
          <span class="go_back_icon" />
          <span class="go_back_txt">返回云市场首页</span>
        </div>
        <div class="go_back_lines" />
      </div>
      <div class="commodity_content serviceInfo">
        <div class="commodity_content_pic">
          <div class="content_img img_service">
            <img :src="url" alt="" height="100%" width="100%">
          </div>
          <div class="little_img flex mt20 pointer">
            <div v-for="(item,i) in detailInfo.goodsMainImgs" :key="i" @click="getUrl(item)">
              <div :class="url===item?'blueBorder':''" class="mr-10 imgUrl">
                <img :src="item" alt="" height="100%" width="100%">
              </div>
            </div>
          </div>
        </div>
        <div class="ml30 commodity content_introduce m_commodity_service">
          <div style="min-width: 800px">
            <div class="f-flex">
              <div class="f-flex1">
                <UmToolTip :content="detailInfo.goodsTitle" class="title" />
                <p class="text mt10">{{ detailInfo.goodsDescription }}</p>
              </div>
              <div class="m_commodity_service_ritem mt10">
                <div><UmCollection v-model="collectionStatus" style="margin-left: 30px;" @change="collectHandler" /></div>
                <div class="m_commodity_service_ritem_im ml30" @click="concactCustomer">
                  <svg-icon class="mr-4 " icon-class="blueLijizixun" />
                  <span class="u_txt">立即咨询</span>
                </div>
              </div>
            </div>
            <div class="top-switch mt-20">
              <div class="redColor flex">
                ¥
                <div class="number">
                  {{ price }}
                </div>
                元
                <div class="ml20 kucun ">
                  （库存：{{ stock }}）
                </div>
                <!--                <UmCollection v-model="collectionStatus" style="margin-left: 30px;" @change="collectHandler" />-->
              </div>
            </div>
            <div>
              <div class="u_tag-title">选择规格</div>
              <div class="text flex  u_tag-wrap  row_one mb10  mr-10">
                <el-tag
                  v-for="(item,i) in detailInfo.specificationList"
                  :key="i"
                  :type="skuUuid==detailInfo.specificationList[i].skuUuid?'':'info'"
                  :class="active===i?'tag1 pointer':'tag pointer'"
                  size="mini"
                  class="row_one"
                  @click="getSpecifications(i)"
                >
                  {{ item.specName }}
                </el-tag>
              </div>
            </div>
          </div>

          <div class="m_commodity_service_tool">
            <div class="flex">
              <el-button type="primary" @click="getBuyNow()">立即购买</el-button>
              <el-button class="btn " type="primary" plain @click="addShopCar">
                <svg-icon class="mr-4 " icon-class="shopCar" />
                加入购物车
              </el-button>
              <el-button class="btn " type="primary" plain @click="getBussinessMobile">
                <svg-icon class="mr-4 " icon-class="bluePhone" />
                联系服务商
              </el-button>
              <!--              <el-button class=" btn " type="primary" plain @click="concactCustomer">-->
              <!--                <svg-icon class="mr-4 " icon-class="blueLijizixun" />-->
              <!--                立即咨询-->
              <!--              </el-button>-->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cloudMarkDetail_product">
      <div class="flex-between mb20" style="border-bottom:1px dashed #E4E8EB">
        <div class="product-title margin">产品详情</div>
        <div class="flex-center ">
          <div class="font-14 mr-4">综合评价</div>
          <UmStar :star="detailInfo.score" />
          <div class="yellowColor font-14">{{ detailInfo.score || 0 }}分</div>
        </div>
      </div>

      <div class="flex-center mt-10">
        <UmEditInfo v-if="detailInfo.content" :url="detailInfo.content" @goInfo="jumpPath" />
        <no-data v-else class="mt40" />
      </div>
    </div>
    <confirm-order-two
      ref="order"
      :address-flag="true"
      :order-info="detailInfo"
      :order-two-flag="orderTwoFlag"
      :platform-order-number="platformOrderNumber"
      :price="price"
      :specification-name="specName"
      :stock="stock"
      :submit-order="submitOrder"
      :tab-type="5"
      :business-order-uuid="businessOrderUuid"
      @changeShow="changeShow"
    />
    <!-- 服务商号码 -->
    <service-provider
      :bussiness-mobile="bussinessMobile"
      :contact-flag="contactFlag"
      @changeContactFlag="changeContactFlag"
    />
  </div>
</template>

<script>
import confirmOrderTwo from '../../components/confirmOrderTwo.vue'
import { getCloudMarketInfo, getSubmitHardwareOrder } from '@/api/cloudMarket'
import ServiceProvider from '../../components/serviceProvider.vue'
import noData from '../../components/noData.vue'
import { mapGetters } from 'vuex'
import imSdk from '@um/im'
import { addCollect, addShopping, cancelCollect, isCollect } from '@/api/dashboard'
import { jumpPath } from '@/utils/jump'

export default {
  name: 'CloudMarketHardwareMallDetails',
  components: { confirmOrderTwo, ServiceProvider, noData },
  data() {
    return {
      jumpPath,
      url: '',
      orderTwoFlag: false,
      detailInfo: {},
      price: 0,
      stock: 0,
      contactFlag: false,
      bussinessMobile: '',
      skuUuid: '',
      specName: '',
      platformOrderNumber: '',
      businessOrderUuid: '',
      collectionStatus: false,
      active: 0
    }
  },
  computed: {
    ...mapGetters(['session', 'sessionList'])
  },
  mounted() {
    this.getDetail()
  },
  methods: {

    collectHandler(status) {
      if (status) {
        addCollect({
          businessType: 2003010103,
          businessUuid: this.$route.query.uuid,
          businessName: this.detailInfo.goodsTitle
        }).then(res => {
          this.$message.success('已收藏！')
        }).catch(e => {
          this.collectionStatus = !this.collectionStatus
        })
      } else {
        cancelCollect({
          businessType: 2003010103,
          businessUuid: this.$route.query.uuid,
          type: 1
        }).then(res => {
          this.$message.success('取消收藏！')
        }).catch(e => {
          this.collectionStatus = !this.collectionStatus
        })
      }
    },
    addShopCar() {
      const load = this.$load()
      addShopping({
        skuList: [
          {
            businessType: 1023903,
            skuUuid: this.skuUuid
          }
        ]
      }).then(res => {
        this.$message.success('添加购物车成功！')
      }).finally(_ => {
        load.close()
      })
    },
    back() {
      if (this.$route.query.tabType != 0) {
        this.$router.push({ path: '/cloudMarket', query: { tabType: this.$route.query.tabType }})
      } else {
        this.$router.push({ path: '/cloudMarket/shoppingCart' })
      }
    },
    // 硬件详情
    getDetail() {
      const load = this.$load()
      getCloudMarketInfo({ uuid: this.$route.query.uuid }).then(res => {
        this.detailInfo = res.data.hardwareInfo
        this.stock = res.data.hardwareInfo.totalStock
        this.bussinessMobile = res.data.hardwareInfo.bussinessMobile
        this.url = res.data.hardwareInfo.goodsMainImgs[0]
        this.price = res.data.hardwareInfo.specificationList[0].specPrice
        this.stock = res.data.hardwareInfo.specificationList[0].specStock
        this.skuUuid = res.data.hardwareInfo.specificationList[0].skuUuid
        this.specName = res.data.hardwareInfo.specificationList[0].specName
        this.collectionStatus = res.data.hardwareInfo.collectFlag
        load.close()
      }).catch(e => {
        load.close()
      })
    },
    // 选择规格
    getSpecifications(i) {
      this.active = i
      this.price = this.detailInfo.specificationList[i].specPrice
      this.stock = this.detailInfo.specificationList[i].specStock
      this.skuUuid = this.detailInfo.specificationList[i].skuUuid
      this.specName = this.detailInfo.specificationList[i].specName
    },
    getBuyNow() {
      if (this.$store.getters.userInfo.adminFlag === true) {
        if (this.skuUuid !== '') {
          this.orderTwoFlag = true
          this.$refs.order.getDefaultAddress()
          this.$refs.order.handleChange()
        } else {
          this.$message.error('请先选择规格')
        }
      } else {
        this.$message.error('非管理员暂时无法购买，请联系管理员购买！')
      }
    },

    changeShow(data) {
      if (data === 'false') {
        this.orderTwoFlag = false
      } else {
        this.orderTwoFlag = true
      }
    },
    getUrl(item) {
      this.url = item
    },
    getBussinessMobile() {
      this.contactFlag = true
    },
    changeContactFlag(data) {
      if (data === 'false') {
        this.contactFlag = false
      } else {
        this.contactFlag = true
      }
    },
    /**
     * 联系客户
     * @param item
     */
    concactCustomer() {
      const { imAccount } = this.detailInfo
      if (!imSdk.YX) return this.$message.warning('聊天功能异常')
      if (!imAccount) return this.$message.warning('客户信息异常！')
      const goodsInfo = {
        shareTitle: this.detailInfo.goodsTitle,
        shareContent: this.detailInfo.goodsDescription,
        shareImageUrl: this.detailInfo.goodsMainImgs[0] || '',
        shareType: 'pc',
        shareLink: `/cloudMarket/info?uuid=${this.$route.query.uuid}&dataType=${this.$route.query.dataType}`,
        price: this.detailInfo.goodsPrice
      }
      imSdk.YX.concactCustomer(imAccount, 'p2p', goodsInfo).then(res => {
        this.$router.push('/im')
      }).catch(e => {
        this.$message.error('操作失败')
      })
    },
    // 下单
    async submitOrder(num, addressUuid) {
      const params = {
        skuUuid: this.skuUuid,
        spuUuid: this.$route.query.uuid,
        amount: num,
        addressUuid: addressUuid,
        organUuid: this.detailInfo.organUuid,
        organName: this.detailInfo.organName
      }
      await getSubmitHardwareOrder(params).then(res => {
        this.platformOrderNumber = res.data.platformOrderNumber
        this.businessOrderUuid = res.data.businessOrderUuid
      })
    }
  }
}
</script>

